<template>
    <b-container fluid class="mt-3 pb-3">
        <b-input-group class="mb-3">
            <b-form-input v-model="folderName"></b-form-input>
            <b-input-group-append>
                <b-button :disabled="!folderName || (portal && portal.folder)" squared @click="showFoldersModal" variant="primary">
                    <b-icon icon="folder-plus"></b-icon>
                    Create folder
                </b-button>
            </b-input-group-append>
        </b-input-group>
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="fill"
                      aria-controls="my-clients"></b-pagination>
        <b-list-group>
            <b-overlay :show="loading">
                <node-file v-for="(client, index) in clientsForList" :key="index" :currentIndex="index.toString()"
                           :node="client" :depth="0" :subFolders="subFolders" :access="access" :portals="portals"
                           @getClientFolders="getClientFolders"></node-file>
            </b-overlay>
        </b-list-group>

        <b-modal :id="foldersModal.id" title="Create folder" @ok="createFolder" size="lg" ok-title="Create"
                 :ok-disabled="(!folderName || !foldersModal.selected || foldersModal.selected.length === 0)
                 || (!foldersModal.portalIds || foldersModal.portalIds.length === 0)">
            <b-row>
                <b-col md="6">
                    <b-form-group label="Folder's name">
                        <b-form-input v-model="folderName"></b-form-input>
                    </b-form-group>
                    <b-form-group  label="Subfolders to create">
                        <b-form-checkbox-group
                            v-model="foldersModal.selected"
                            :options="subFolders"
                            name="flavour-2a"
                            stacked
                        ></b-form-checkbox-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Portal Access">
                        <b-form-select v-if="portals" id="portal" name="portal" multiple
                                       v-model="foldersModal.portalIds" required>
                            <b-form-select-option v-for="selectPortal in portals"
                                                  :key="selectPortal.id"
                                                  :value="selectPortal.id">
                                {{ selectPortal.name }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
    </b-container>
</template>

<script>
    import FileService from "../../services/FileService";
    import NodeFile from "./NodeFile";
    import PortalDataService from "@/services/PortalDataService";

    export default {
        name: "Files",
        components: {
            NodeFile
        },
        created() {
            document.title = "Configuration : Files";
        },
        props: {
            portal: Object,
        },
        data() {
            return {
                clients: null,
                access: null,
                portals: null,
                folderName: "",
                subFolders: [
                    { text: 'css', value: 'css' },
                    { text: 'images', value: 'images'},
                    { text: 'fonts', value: 'fonts'},
                ],
                foldersModal: {
                    id: 'modal-folders-field',
                    selected: [],
                    portalIds: []
                },
                loading: false,
                perPage: 15,
                currentPage: 1,
            }
        },
        mounted() {
            this.getClientFolders();
            this.getPortals();
        },
        computed: {
            isAdmin() {
                return this.$store.getters.isAdmin;
            },
            currentUser() {
                return this.$store.state.auth.user;
            },
            rows() {
                return this.clients ? this.clients.length : 0;
            },
            clientsForList() {
                if (this.clients) {
                    return this.clients.slice(
                        (this.currentPage - 1) * this.perPage,
                        this.currentPage * this.perPage,
                    );
                } else {
                    return null;
                }
            }
        },
        methods: {
            getPortals() {
                if (!this.isAdmin) {
                    PortalDataService.findByManager(this.currentUser.email)
                        .then(response => (this.portals = response.data))
                        .catch(error => console.log(error))
                } else {
                    PortalDataService.getAll()
                        .then(response => (this.portals = response.data))
                        .catch(error => console.log(error))
                }
            },
            getClientFolders() {
                this.loading = true;
                FileService.getClientFolders()
                    .then(response => {
                        this.clients = response.data;
                        this.getFolderAccess();
                    })
                    .catch(error => console.log(error))
            },
            getFolderAccess() {
                FileService.getFolderAccessByEmail(this.currentUser.email)
                    .then(response => {
                        this.access = response.data;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loading = false;
                    })
            },
            showFoldersModal() {
                this.foldersModal.selected = ['css', 'images', 'fonts'];
                this.foldersModal.portalIds = [];
                this.$root.$emit('bv::show::modal', this.foldersModal.id)
            },
            createFolder() {
                this.$bvModal.show('loading-modal');
                FileService.createClientFolders(this.folderName, this.foldersModal.selected, true)
                    .then(() => {
                        this.$parent.displaySuccessMessage('The folder was successfully created.');
                        FileService.giveFolderAccess(this.folderName, this.foldersModal.portalIds)
                        this.getClientFolders();
                        this.folderName = '';
                    })
                    .catch(error => {
                        console.log(error);
                        this.$parent.displayErrorMessage('An error occurred while trying to create the folder.');
                    });
            },
        }
    }
</script>

<style scoped>

</style>